export default __webpack_public_path__ + "5860f1ec518da9c8f9e7cdf2b674f60a.svg";